<template>
    <!-- 任职记录列表 -->
    <vHierarchyPersonList :postList="postList" v-if="flag"></vHierarchyPersonList>
</template>
<script>
import vHierarchyPersonList from '../../listComponent/jurisdiction/hierarchyPersonListComponent.vue';
export default {
    name: 'hierarchyPersonList',
    components: {
        vHierarchyPersonList
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                status: true,
                person_rid: true,
                hierarchy_rid: true,
                department_rid: true,
                concentration: true,
                start_date_range: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>